var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8317 3.89075C9.63844 1.69747 6.08404 1.69747 3.89075 3.89075C1.69747 6.08404 1.69747 9.63844 3.89075 11.8317C6.08404 14.025 9.63844 14.025 11.8317 11.8317C14.025 9.63844 14.025 6.08404 11.8317 3.89075ZM17.6715 17.6715C17.2324 18.1095 16.5215 18.1095 16.0824 17.6715L12.546 14.134C9.46662 16.4362 5.10026 16.2183 2.30278 13.4197C-0.767594 10.3504 -0.767594 5.37316 2.30278 2.30278C5.37204 -0.767594 10.3504 -0.767594 13.4197 2.30278C16.2183 5.10026 16.4362 9.46662 14.134 12.546L17.6715 16.0835C18.1095 16.5215 18.1095 17.2324 17.6715 17.6715Z",
    fill: "#292F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.84fc4343ccfdc3268dbc5952ab786efe.svg";
export { ForwardRef as ReactComponent };